import { useRouter } from 'next/router';
import { useEffect, useRef } from 'react';

// https://github.com/vercel/next.js/discussions/20784#discussioncomment-4101864
type WindowWithDataLayer = Window & {
  dataLayer: Record<string, unknown>[];
};
declare const window: WindowWithDataLayer;

export const gtmDataLayerPush = (data: Record<string, unknown>) => {
  if (window && window.dataLayer) {
    window.dataLayer.push(data);
  }
};

export const useGTMPageView = () => {
  const router = useRouter();
  const triggeredOnPageLoad = useRef(false);

  useEffect(() => {
    const isInitialPageLoad = !triggeredOnPageLoad.current;

    const trackPageView = (url: string) => {
      try {
        if (router.pathname !== '/404') {
          // Trigger a custom event called SPAPageView with the page data.
          // GTM will be configured to listen to this event.
          const data = {
            event: 'SPAPageView',
            pageTitle: window?.document.title || '',
            pagePath: url,
          };

          gtmDataLayerPush(data);

          if (!isInitialPageLoad) {
            // Trigger the gtm.load event on subsequent navigations which resets most
            // GTM triggers (like scroll depth)
            gtmDataLayerPush({ event: 'gtm.load' });
          }
        }
      } catch (error) {
        console.log(error);
      }
    };

    if (isInitialPageLoad && window) {
      trackPageView(window.location.pathname);
      triggeredOnPageLoad.current = true;
    }

    const routeChangeHandler = (url: string) => setTimeout(() => trackPageView(url), 100);

    router.events.on('routeChangeComplete', routeChangeHandler);
    return () => {
      router.events.off('routeChangeComplete', routeChangeHandler);
    };
  }, [router]);
};
